import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class AdaniGasStationLocationFilter extends Component {
    state = {
        gasStationLocationLists:[],
        gasStationLocationValue:null,

    };
    componentDidMount(){
        this._get_adani_gas_station_name();
    }

    resetGasStationLocationFilter(){
        this.setState({
        gasStationLocationValue: [],
        })
    }
     _get_adani_gas_station_name(){
        axios.get(config.get('API_URL')+'/filters/get-gas-station-location/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((location, index) => {
                    this.state.gasStationLocationLists.push({value: location.location_gas_station, label: location.location_gas_station})
                });
            }
        });
     }
     changeGasStationLocation(optionSelected){
        let value='';
        let gasStationLocationArray = [];
        if(optionSelected.length < 1){
            value = null;
            gasStationLocationArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                gasStationLocationArray.push(mids.value)
                var index = this.state.gasStationLocationLists.findIndex(obj => obj.value==mids.value);
                this.state.gasStationLocationLists.move(index,0).join(',');

            });
        }
        this.props.onSelectGasStationLocation(optionSelected,gasStationLocationArray);
        this.setState({
            gasStationLocationValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="email"
            isMulti
            value={this.state.gasStationLocationValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeGasStationLocation.bind(this)}
            options={this.state.gasStationLocationLists}
            placeholderButtonLabel="Select [Location]"
        />
        );

    }
}
export default AdaniGasStationLocationFilter;